import {
  HOME_TRANSFER_OWNERSHIP_BEGIN,
  HOME_TRANSFER_OWNERSHIP_SUCCESS,
  HOME_TRANSFER_OWNERSHIP_FAILURE,
  HOME_TRANSFER_OWNERSHIP_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { builderAuthHeader, errorLogOut } from '../../common/utils/auth';

export function transferOwnership(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_TRANSFER_OWNERSHIP_BEGIN,
    });
    const { projectId, email } = args;
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        process.env.REACT_APP_ORGANIZATION_ENGINE_URL +
          `clients/generate-transfer-request/` +
          email +
          '/project/' +
          projectId,
        {},
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_TRANSFER_OWNERSHIP_SUCCESS,
            data: res,
          });
          resolve(res);
          if (res.data.status === 'success') {
            toast.success(res.data.message);
          } else if (res.data.status === 'failed') {
            toast.error(res.data.message);
          } else {
            toast.error('Transfer request failed.');
          }
        },
        (err) => {
          dispatch({
            type: HOME_TRANSFER_OWNERSHIP_FAILURE,
            data: { error: err },
          });
          reject(err);
          if (err.response.status === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Session Expired',
            }).then((result) => {
              if (result.value) {
                errorLogOut();
              }
            });
          } else {
            toast.error('Transfer request failed.');
          }
        },
      );
    });

    return promise;
  };
}

export function dismissTransferOwnershipError() {
  return {
    type: HOME_TRANSFER_OWNERSHIP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_TRANSFER_OWNERSHIP_BEGIN:
      return {
        ...state,
        transferOwnershipPending: true,
        transferOwnershipError: null,
      };

    case HOME_TRANSFER_OWNERSHIP_SUCCESS:
      return {
        ...state,
        transferOwnershipPending: false,
        transferOwnershipError: null,
      };

    case HOME_TRANSFER_OWNERSHIP_FAILURE:
      return {
        ...state,
        transferOwnershipPending: false,
        transferOwnershipError: action.data.error,
      };

    case HOME_TRANSFER_OWNERSHIP_DISMISS_ERROR:
      return {
        ...state,
        transferOwnershipError: null,
      };

    default:
      return state;
  }
}
